module.exports = "<svg class=\"icon icon-{{ vm.name }}\">\n  <use xlink:href=\"\" ng-attr-xlink:href=\"{{ '#' + vm.name | trustedUrl }}\"></use>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fino/ng1-icon/src/icon.html
// module id = 1509
// module chunks = 12